import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import styles from "../styles/theme";

const eyeOpen = (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#d97706" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
    <circle cx="12" cy="12" r="3"/>
  </svg>
);
const eyeClosed = (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#d97706" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
    <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
    <line x1="1" y1="1" x2="23" y2="23"/>
  </svg>
);

const eyeBtn = {
  position: 'absolute', right: 0, top: 0, bottom: 0, width: 48,
  display: 'flex', alignItems: 'center', justifyContent: 'center',
  background: 'transparent', border: 'none', cursor: 'pointer', padding: 0,
};

export default function SignupPage({ authForm, setAuthForm, authError, authLoading, onSignUp, onBack, onSwitchToLogin }) {
  const location = useLocation();
  const preSelected = location.state?.accountType || null;
  const [accountType, setAccountType] = useState(preSelected); // null = choosing, 'technician' or 'employer'
  const [agreedToTerms, setAgreedToTerms] = useState(false);
  const [showTermsError, setShowTermsError] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  if (!accountType) {
    return (
      <div style={styles.formWrap} data-form-wrap>
        <button style={styles.backBtn} data-back-btn onClick={onBack}>{"\u2190"} Back</button>
        <div style={styles.formCard} data-form-card>
          <h2 style={styles.formTitle} data-form-title>Create Account</h2>
          {location.state?.message && (
            <div style={{ background: '#1a1408', border: '1px solid #d97706', borderRadius: 8, padding: '10px 14px', color: '#d97706', fontSize: 13, marginBottom: 16 }}>
              {location.state.message}
            </div>
          )}
          <p style={{ color: '#9a9490', fontSize: 14, margin: '0 0 20px', lineHeight: 1.5 }}>
            Choose your account type to get started.
          </p>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            <div
              onClick={() => setAccountType('technician')}
              style={{
                background: '#0d0f10', border: '2px solid #2a2c2e', borderRadius: 10,
                padding: '24px 20px', cursor: 'pointer', transition: 'border-color 0.15s',
              }}
              onMouseEnter={e => e.currentTarget.style.borderColor = '#d97706'}
              onMouseLeave={e => e.currentTarget.style.borderColor = '#2a2c2e'}
            >
              <div style={{ fontSize: 28, marginBottom: 8 }}>{"\uD83E\uDE96"}</div>
              <div style={{ fontSize: 18, fontWeight: 'bold', color: '#e8e4dc', marginBottom: 6 }}>I'm a Technician</div>
              <div style={{ fontSize: 13, color: '#7a7570', lineHeight: 1.5 }}>
                Create your UXO technician profile, track certifications, and get matched with jobs.
              </div>
            </div>
            <div
              onClick={() => setAccountType('employer')}
              style={{
                background: '#0d0f10', border: '2px solid #2a2c2e', borderRadius: 10,
                padding: '24px 20px', cursor: 'pointer', transition: 'border-color 0.15s',
              }}
              onMouseEnter={e => e.currentTarget.style.borderColor = '#d97706'}
              onMouseLeave={e => e.currentTarget.style.borderColor = '#2a2c2e'}
            >
              <div style={{ fontSize: 28, marginBottom: 8 }}>{"\uD83C\uDFE2"}</div>
              <div style={{ fontSize: 18, fontWeight: 'bold', color: '#e8e4dc', marginBottom: 6 }}>I'm an Employer</div>
              <div style={{ fontSize: 13, color: '#7a7570', lineHeight: 1.5 }}>
                Post jobs, browse certified technicians, and manage your hiring pipeline.
              </div>
            </div>
          </div>
          <p style={{ color: '#7a7570', fontSize: 13, textAlign: 'center', marginTop: 16 }}>
            Already have an account?{' '}
            <span style={{ color: '#d97706', cursor: 'pointer' }} onClick={onSwitchToLogin}>Log in</span>
          </p>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.formWrap} data-form-wrap>
      <button style={styles.backBtn} data-back-btn onClick={onBack}>{"\u2190"} Back</button>
      <div style={styles.formCard} data-form-card>
        <h2 style={styles.formTitle} data-form-title>Create Account</h2>
        {location.state?.message && (
          <div style={{ background: '#1a1408', border: '1px solid #d97706', borderRadius: 8, padding: '10px 14px', color: '#d97706', fontSize: 13, marginBottom: 12 }}>
            {location.state.message}
          </div>
        )}
        <div style={{
          display: 'inline-block', background: accountType === 'technician' ? '#1a2a08' : '#1a1408',
          border: `1px solid ${accountType === 'technician' ? '#4ade80' : '#d97706'}`,
          color: accountType === 'technician' ? '#4ade80' : '#d97706',
          fontSize: 12, padding: '3px 10px', borderRadius: 12, marginBottom: 16,
          cursor: 'pointer',
        }} onClick={() => setAccountType(null)}>
          {accountType === 'technician' ? '\uD83E\uDE96 Technician' : '\uD83C\uDFE2 Employer'} Account {"\u2022"} Change
        </div>
        <div style={styles.formFields} data-form-fields>
          <label style={styles.label}>Email</label>
          <input style={styles.input} type="email" placeholder="you@email.com" value={authForm.email} onChange={e => setAuthForm(f => ({ ...f, email: e.target.value }))} />
          <label style={styles.label}>Password</label>
          <div style={{ position: 'relative' }}>
            <input style={{ ...styles.input, paddingRight: 48 }} type={showPassword ? 'text' : 'password'} placeholder="Minimum 6 characters" value={authForm.password} onChange={e => setAuthForm(f => ({ ...f, password: e.target.value }))} />
            <button type="button" onClick={() => setShowPassword(v => !v)} style={eyeBtn} tabIndex={-1} aria-label={showPassword ? 'Hide password' : 'Show password'}>
              {showPassword ? eyeClosed : eyeOpen}
            </button>
          </div>
          {authError && <div style={styles.errorMsg}>{"\u26A0\uFE0F"} {authError}</div>}
          <label style={{ display: "flex", alignItems: "flex-start", gap: 10, cursor: "pointer", margin: "4px 0" }}>
            <input
              type="checkbox"
              checked={agreedToTerms}
              onChange={e => { setAgreedToTerms(e.target.checked); setShowTermsError(false); }}
              style={{ marginTop: 3, accentColor: "#d97706", flexShrink: 0 }}
            />
            <span style={{ fontSize: 13, color: "#9a9490", lineHeight: 1.5 }}>
              I agree to the{" "}
              <Link to="/terms" target="_blank" style={{ color: "#d97706", textDecoration: "none" }}>Terms of Service</Link>
              {" "}and{" "}
              <Link to="/privacy" target="_blank" style={{ color: "#d97706", textDecoration: "none" }}>Privacy Policy</Link>
            </span>
          </label>
          {showTermsError && <div style={styles.errorMsg}>{"\u26A0\uFE0F"} You must agree to the Terms of Service and Privacy Policy to create an account.</div>}
          <button style={styles.btnPrimary} data-btn-primary onClick={() => {
            if (!agreedToTerms) { setShowTermsError(true); return; }
            onSignUp(accountType);
          }} disabled={authLoading}>
            {authLoading ? 'Creating account...' : 'Create Account'}
          </button>
          <p style={{ color: '#7a7570', fontSize: 13, textAlign: 'center' }}>
            Already have an account?{' '}
            <span style={{ color: '#d97706', cursor: 'pointer' }} onClick={onSwitchToLogin}>Log in</span>
          </p>
        </div>
      </div>
    </div>
  );
}
